export default __webpack_public_path__ + "static/media/bj4.6aad3dce.png";